<template>
<button class="linkbtn">
  <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1295_46485)">
    <path fill="none" d="M21 27L17.1075 19.8638C16.4221 18.6072 17.7183 17.1961 19.0285 17.7725L36.8796 25.627C38.0741 26.1526 38.0741 27.8474 36.8796 28.373L19.0285 36.2275C17.7183 36.8039 16.4221 35.3928 17.1075 34.1362L21 27ZM21 27H30" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <path d="M4 2H50V-2H4V2ZM52 4V50H56V4H52ZM50 52H4V56H50V52ZM2 50V4H-2V50H2ZM4 52C2.89543 52 2 51.1046 2 50H-2C-2 53.3137 0.686293 56 4 56V52ZM52 50C52 51.1046 51.1046 52 50 52V56C53.3137 56 56 53.3137 56 50H52ZM50 2C51.1046 2 52 2.89543 52 4H56C56 0.686291 53.3137 -2 50 -2V2ZM4 -2C0.686291 -2 -2 0.686293 -2 4H2C2 2.89543 2.89543 2 4 2V-2Z" fill="#E9041E" stroke="none"/>
    <defs>
    <clipPath id="clip0_1295_46485">
    <rect stroke="none" width="24" height="24" transform="translate(15 15)"/>
    </clipPath>
    </defs>
  </svg>
</button>
</template>

<script>
  export default {
    
  }
</script>

<style lang="sass" scoped>
.linkbtn
  cursor: pointer
  display: block
  border-radius: 4px
  overflow: hidden
  transition: .3s ease-out
  svg
    transition: .2s ease-out
    stroke: colors.$brown
  &:hover, &:active
    background: colors.$red
    svg
      stroke: white
</style>